import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pumpkin"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.00187 8.00001C4.12876 5.74119 6.84183 5.78431 7.78092 6.41176C8.25045 6.09804 9.75297 5 12.0068 5C14.2606 5 15.7631 6.09803 16.2326 6.41175C17.1717 5.7843 19.876 5.74119 21.0029 8.00001C22.4116 10.8235 20.4585 20.0588 17.1717 20.0588C16.2326 20.0588 14.824 20.0588 14.824 20.0588C14.511 20.5294 13.8849 21 12.0068 21C10.1286 21 9.50254 20.5294 9.18952 20.0588C9.18952 20.0588 7.31136 20.0588 6.37229 20.0588C3.55503 20.0588 1.59324 10.8235 3.00187 8.00001Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.9128 5.0006C9.70984 5.02972 8.24162 6.10231 7.77848 6.41176C5.90031 10.5529 7.93497 18.4902 9.18708 20.0588C9.5001 20.5294 10.1262 21 12.0043 21C13.8825 21 14.5085 20.5294 14.8216 20.0588C16.0737 18.4902 18.1084 10.5529 16.2302 6.41175C15.7607 6.09803 14.2581 5 12.0043 5C11.9737 5 11.9432 5.0002 11.9128 5.0006ZM11.9128 5.0006C11.8031 4.16707 11.5562 3.33353 11.0005 2.5M11.9128 5.0006C12.0005 5.66707 12.0005 6.33354 12.0005 7M15.2995 20.0589H17.1693C20.4561 20.0589 22.4091 10.8236 21.0005 8.00005C19.9674 5.92927 17.6086 5.79311 16.4995 6.26822M8.69951 20.0589H6.82972C3.54294 20.0589 1.5899 10.8236 2.99852 8.00005C4.03161 5.92927 6.3904 5.79311 7.49951 6.26822","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Pumpkin = Vue.extend<IconProps>({
  name: 'PumpkinIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pumpkin',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Pumpkin;
